export default "__VITE_ASSET__DiSn6rE2__"